/* eslint-disable react/no-unescaped-entities */
import Head from 'next/head';
import styled from '@emotion/styled';
import Image from '@base/Image';
import { NextSeo } from 'next-seo';
import H1 from '@base/H1/H1';
import P2 from '@base/P2/P2';
import SimpleLayout from '@layout/index';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const unavailableImage = 'unavailable.png';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  grid-column: span 24;
  width: 100%;
  height: calc(100vh - 120px);
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  flex-direction: column;
`;

const StyledH1 = styled(H1)`
  font-size: 56px;
  margin-bottom: 24px;
`;

const StyledP1 = styled(P2)`
  font-size: 24px;
  width: 100%;
`;

const UnAvailable = () => {
  const title = 'Not Available';

  return (
    <>
      <NextSeo
        title={title}
        openGraph={{
          title
        }}
      />
      <Head>
        <title>Not Available</title>
      </Head>
      <Wrapper>
        <Flex>
          <StyledH1>Sorry we aren't available here yet</StyledH1>
          <StyledP1 color="var(--color-text-secondary)">
            Stay tuned! We are coming soon.
          </StyledP1>
        </Flex>
        <Flex>
          <Image
            src={unavailableImage}
            alt="not-available"
            width={560}
            height={560}
          />
        </Flex>
      </Wrapper>
    </>
  );
};

UnAvailable.pageInfo = {
  name: 'Unacademy Unavailable',
  isMWebSupported: true,
  layoutOptions: {
    isCheckoutUrl: true,
    hideSearch: true,
    hideFooter: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

export default UnAvailable;
UnAvailable.Layout = SimpleLayout;
UnAvailable.Wrapper = PageReduxProvider;
